import { useCallback } from 'react';
import { EDCard } from '../../BaseComponents/Card/EDCard';
import Logo from '../../Assets/Branding/Aveny_logo_dark.svg';
import EDBox from '../../BaseComponents/EDBox/EDBox';
import EDTypography from '../../BaseComponents/Typography/EDTypography';
import EDButton from '../../BaseComponents/Buttons/Button/EDButton';
import { useIsSmallBreakpoint } from '../BreakpointContext/BreakpointContextUtils';
import { CookieSettingsDialog } from '../CookieSettings/CookieSettingsDialog';
import { useBoolState } from '../../Hooks/booleanHooks';
import { CONSENT_ALL, IConsent } from '../CookieSettings/CookieSettingsUtils';

interface IProps {
  consent: IConsent;
  setConsent: (consent: IConsent) => void;
}

const CookieBar = (props: IProps) => {
  const { setConsent } = props;
  const isSmall = useIsSmallBreakpoint();
  const [settingsOpen, showSettings, hideSettings] = useBoolState(false);
  const acceptAll = useCallback(() => {
    setConsent(CONSENT_ALL);
  }, [setConsent]);
  return (
    <>
      <EDBox
        sx={[
          {
            position: 'absolute',
            bottom: isSmall ? 0 : 30,
            zIndex: 100000,
            visibility: settingsOpen ? 'hidden' : 'visible',
          },
          !isSmall && { left: '50%', transform: 'translateX(-50%)' },
        ]}
      >
        <EDCard elevation={20} maxWidth={920}>
          <EDBox
            sx={{
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            {!isSmall && (
              <img
                src={Logo}
                alt="Aveny Logo" /**Har vi någon komponent som vi använder för att visa en bild (ist för img-taggen..)?  */
              />
            )}
            <EDBox
              sx={{
                padding: '20px 20px 20px 20px',
              }}
            >
              <EDTypography variant={isSmall ? 'h5' : 'h4'}>
                Vi bryr oss om din integritet!
              </EDTypography>
              <EDTypography variant="body2">
                Vi använder cookies och liknande teknik för grundläggande
                programfunktionalitet, analys av programanvändning och för att
                hantera fel som uppstår. Genom att klicka på ”tillåt alla” så
                godkänner du detta. Du kan också välja ”inställningar för
                datainsamling” för fler alternativ.
              </EDTypography>
              <EDBox
                sx={{
                  paddingTop: '35px',
                  textAlign: 'end',
                }}
              >
                <EDButton
                  flat
                  label={'Inställningar för datainsamling'}
                  onClick={showSettings}
                />
                <EDButton
                  marginLeft={3}
                  label={'Tillåt alla'}
                  onClick={acceptAll}
                  testId={'integritetsinställningar-Tillåt alla'}
                />
              </EDBox>
            </EDBox>
          </EDBox>
        </EDCard>
      </EDBox>
      <CookieSettingsDialog
        open={settingsOpen}
        onClose={hideSettings}
        consent={props.consent}
        setConsent={props.setConsent}
      />
    </>
  );
};

export default CookieBar;
